import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
//import { Link, useHistory } from "react-router-dom";
import { styled } from "@mui/material/styles";
import MuiBreadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import MuiLink from "@mui/material/Link";
//import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";

//import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { selectDrawer } from "../reducers/appSlice";

const drawerWidth = 256;

const BreadcrumbsContainer = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "drawer",
})(({ theme, drawer }) => ({
  marginTop: 56,
  height: 49,
  backgroundColor: "white",
  borderBottom: "1px solid #e0e0e0",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  ...(drawer && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const BreadcrumbsContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  [theme.breakpoints.up("md")]: {
    marginLeft: 24,
  },
  [theme.breakpoints.down("md")]: {
    paddingLeft: theme.spacing(2),
  },
}));

const StyledLink = styled(MuiLink)(({ theme }) => ({
  color: "#799F4F",
  "&:hover": {
    color: "#799F4F",
  },
}));

const PageBreadcrumbs = (props) => {
  //const history = useHistory();
  const crumbs = [];
  const drawer = useSelector(selectDrawer);

  props.data.forEach((elemento) => {
    let item = null;

    if (elemento.ruta !== "") {
      item = (
        <StyledLink
          component={Link}
          key={elemento.ruta}
          to={elemento.ruta}
          variant="body2"
        >
          <Typography variant="body2">{elemento.nombre}</Typography>
        </StyledLink>
      );
    } else {
      item = (
        <Typography key={elemento.ruta} variant="body2" color="secondary">
          {elemento.nombre}
        </Typography>
      );
    }

    crumbs.push(item);
  });

  /*const back = () => {
    let cantidad = props.data.length;
    let ruta = (cantidad > 2
      ? "/" + props.data[cantidad - 2].ruta
      : ""
    ).replace(/^\/+|\/+$/g, "");

    history.push("/" + ruta);
  };*/

  return (
    <BreadcrumbsContainer elevation={0} drawer={drawer}>
      <BreadcrumbsContent>
        {/*<IconButton
            color="secondary"
            size="small"
            component="span"
            onClick={back}
            sx={{ mr: 1 }}
          >
            <ArrowBackIcon size="small" />
          </IconButton>*/}
        <MuiBreadcrumbs aria-label="breadcrumbs">{crumbs}</MuiBreadcrumbs>
      </BreadcrumbsContent>
    </BreadcrumbsContainer>
  );
};

export default PageBreadcrumbs;
